import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_SHARE_PROMOTE_SLIDE_UP_EXPERIMENT = defineFcm('revenue_share_promote_slide_up_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'PSF share page (second share screen)',
		description:
			'Gates the Second Promote Ask R1 experiment that shows a promote bottom sheet after Continue/Skip on the PSF second share screen.',
		template: {
			enabled: false,
			experimentName: '',
		},
	});
